module.exports = __webpack_public_path__ + "img/ring_y_s_null_null@2x.98bae95f.png";